import React, { useEffect, useState } from "react";
import { api, formatErr } from "../../api";
import { SectionTitle, Avatar, EmptyState } from "../../components/Atoms";
import { Trophy, Crown, WarningCircle } from "@phosphor-icons/react";
import { useAuth } from "../../AuthContext";

export default function LeaderboardPage() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [loadError, setLoadError] = useState(null);
  const load = async () => {
    setLoadError(null);
    try {
      const { data } = await api.get("/leaderboard");
      setList(data);
    } catch (e) {
      setLoadError(formatErr(e));
    }
  };
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-5">
      <SectionTitle title="Leaderboard" subtitle="Top creators on CrewHQ" />
      {loadError ? (
        <div className="glass p-8 flex flex-col items-center gap-3 text-center">
          <WarningCircle size={32} weight="fill" className="text-[#EC4899]" />
          <div className="text-white font-bold">Couldn't load the leaderboard</div>
          <div className="text-muted text-sm">{loadError}</div>
          <button onClick={load} className="btn-primary text-sm px-4 py-2 mt-2">Retry</button>
        </div>
      ) : list.length === 0 ? <EmptyState icon={Trophy} /> : (
        <div className="space-y-2">
          {list.map((a, i) => {
            const isMe = a.id === user?.ref_id;
            const top = i < 3;
            const rankColor = i === 0 ? "#F59E0B" : i === 1 ? "#22D3EE" : i === 2 ? "#EC4899" : "#9CA3AF";
            return (
              <div key={a.id} className={`glass p-4 flex items-center gap-3 hover-lift ${isMe ? "border-[#8B5CF6]/50" : ""}`} data-testid={`leaderboard-row-${a.id}`}>
                <div className="w-10 h-10 grid place-items-center rounded-full font-black text-sm" style={{ background: `${rankColor}25`, color: rankColor }}>
                  {top ? <Crown size={18} weight="fill" /> : `#${i+1}`}
                </div>
                <Avatar src={a.photo} name={a.name} size={44} />
                <div className="flex-1 min-w-0">
                  <div className="text-white font-bold truncate flex items-center gap-2">
                    {a.name}
                    {isMe && <span className="pill completed">You</span>}
                  </div>
                  <div className="text-xs text-muted truncate">{a.city || "—"} · {(a.instagram_followers || 0).toLocaleString()} followers</div>
                </div>
                <div className="text-right">
                  <div className="text-white font-black text-lg">{a.performance_score}</div>
                  <div className="text-[10px] uppercase font-bold tracking-wider text-muted">score</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
